import { chakra } from '@plurall/elo-v3';

import {
  learningPathsListPageGridRecipe,
  learningPathsListPagePaginationRecipe,
  learningPathsListPageStateRecipe,
} from './learning-paths-list-page.recipe';

export const LearningPathsListPageGridFactory = chakra('div', learningPathsListPageGridRecipe);
export const LearningPathsListPageStateFactory = chakra('div', learningPathsListPageStateRecipe);
export const LearningPathsListPagePaginationFactory = chakra('div', learningPathsListPagePaginationRecipe);
